import React from 'react';
import sanitizeHtml from 'sanitize-html-react';

class TitleView extends React.Component {
	render() {
		return (
			<div style={{
				textAlign: 'center',
				paddingTop: 20,
				paddingLeft: 28,
				paddingRight: 28,
				fontSize: 24,
				paddingBottom: 44,
				fontWeight: 500
			}}>
			{this.formatTitle(this.props.title)}
			</div>
		);
	}

	formatTitle(str) {
		// str = str.replace(/(?:\r\n|\r|\n)/g, '<br />');
		return str;
	}
}

export default TitleView;


// WEBPACK FOOTER //
// ./src/components/titleview.jsx